import { InputRules } from '@/types/inputs';
import { FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

export function buildInputRulesObject(label: string, rules?: InputRules) {
  const builtRulesObject: Omit<
    RegisterOptions<FieldValues, FieldPath<FieldValues>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  > = {};

  if (!rules) {
    return {};
  }

  if (rules.required) {
    builtRulesObject.required = {
      value: true,
      message: `${label} is required`,
    };
  }

  if (rules.min) {
    builtRulesObject.min = {
      value: rules.min,
      message: `${label} must be greater than ${rules.min}`,
    };
  }

  if (rules.max) {
    builtRulesObject.max = {
      value: rules.max,
      message: `${label} must be less than ${rules.max}`,
    };
  }

  if (rules.minLength) {
    builtRulesObject.minLength = {
      value: rules.minLength,
      message: `${label} must have more than ${rules.minLength} ${
        rules.minLength === 1 ? 'character' : 'characters'
      }`,
    };
  }

  if (rules.maxLength) {
    builtRulesObject.maxLength = {
      value: rules.maxLength,
      message: `${label} must have less than ${rules.maxLength} ${
        rules.maxLength === 1 ? 'character' : 'characters'
      }`,
    };
  }

  if (rules.pattern) {
    builtRulesObject.pattern = {
      value: rules.pattern.regex,
      message: `${label} is an invalid ${rules.pattern.readablePatternName}`,
    };
  }

  if (rules.validate) {
    builtRulesObject.validate = rules.validate;
  }

  return builtRulesObject;
}
